import { FormControl, InputBase, styled } from '@mui/material';
import React from 'react';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';

const SearchWrapper = styled('div')(({ theme }) => ({
    position: 'relative',
    width: '100%',
    maxWidth: '100%',
    display: 'flex',
    alignItems: 'center',
    backgroundColor: theme.palette.background.default,
    padding: '4px 8px 4px 32px',
    borderRadius: '500px',
    boxShadow: theme.palette.boxShadow,
}));

const IconLeft = styled('div')(({ theme }) => ({
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    left: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 10,
    color: theme.palette.primary.main,
}));

// const IconRight = styled('div')(({ theme }) => ({
//     padding: theme.spacing(0, 1),
//     height: '100%',
//     position: 'absolute',
//     right: 0,
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     zIndex: 10,
// }));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
    color: 'inherit',
    width: '100%',
    '& .MuiInputBase-input': {
        color: theme.palette.text.primary,
        padding: theme.spacing(0, 1),
        fontSize: '0.875rem',
        fontWeight: '400',
        lineHeight: '1.43',
        letterSpacing: '0.01071em',
        marginInline: theme.spacing(1),
        transition: theme.transitions.create('width'),
        width: '100%',
        // '&:focus': {
        //     backgroundColor: theme.palette.custom.search.focus,
        //     boxShadow: 'rgba(0, 0, 0, 0.24) 0px 1px 3px',
        //     borderRadius: '20px',
        // },
    },
}));

const Search = props => {
    const { wrapperProps, placeholder = 'Cerca', ...rest } = props;
    return (
        <React.Fragment>
            <SearchWrapper {...wrapperProps}>
                <IconLeft>
                    <SearchOutlinedIcon fontSize='small' />
                </IconLeft>
                <FormControl fullWidth>
                    <StyledInputBase sx={{ flex: 1 }} placeholder={placeholder} {...rest} />
                </FormControl>
            </SearchWrapper>
        </React.Fragment>
    );
};

export default Search;
